import CoverModal from './CoverModal';

export default CoverModal;
